/**
 * Special contrast verison for websites
 *
 * @link https://github.com/codex-team/codex.special
 * @author Codex Team — ifmo.su
 *   Vitaly Guryn    https://github.com/talyguryn
 *   Savchenko Petr  https://github.com/neSpecc
 * @version 1.2.1
 */

/** Script */
module.exports = require('./codex-special');



//////////////////
// WEBPACK FOOTER
// ./src/js/main.js
// module id = 0
// module chunks = 0